import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { getBranch } from '../../store/user/selectors'

import { gustoApi } from '../../resources/hooks/api/gustoApiHook'
import { URLS } from '../../resources/constants'
import { getGustoSession } from '../../store/settings/selectors'
import { useSettingsApi } from '../../resources/hooks/api/useSettingsApiHook'

interface Props { }

const GustoConnection: React.FC<Props> = () => {

    const navigate = useNavigate();
    const { gustoFetchClientId } = gustoApi();
    const branchData = useSelector(getBranch);
    const gustoSession = useSelector(getGustoSession);
    const { fetchAccountSettingsData } = useSettingsApi();

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [selectedItem, setSelectedItem] = useState<string>('gusto')
    const newWindow: any = useRef(null);

    const handleLogin = () => {
        _handleGustoAuth();
    }

    const _handleGustoAuth = () => {
        setIsLoading(true)
        gustoFetchClientId({}, (message: string, resp: any) => {
            const {auth_url, client_id} = resp.data.data
            const url = auth_url + '?client_id=' + client_id + '&redirect_uri=' + window.location.origin + URLS.GUSTO_CALLBACK + '&response_type=code&scope=public';
            _handleLoginWindow(url);
            setIsLoading(false);
        }, (message: string, resp: any) => {
            setIsLoading(false)
        })
    }

    const _handleLoginWindow = (authUrl: string) => {
        const width = 600;
        const height = 400;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        newWindow.current = window.open(authUrl, 'Gusto Login', `width=${width},height=${height},top=${top},left=${left}`);

        if ( newWindow.current ) {
            const checkIfWindowClosed = setInterval(() => {
                if ( newWindow.current && newWindow.current.closed ) {
                    clearInterval(checkIfWindowClosed);
                    handleWindowClose();
                }
            }, 500);

            newWindow.current.checkInterval = checkIfWindowClosed;
        }
    }

    const handleWindowClose = () => {
        getSettingsData();
        newWindow.current = null;
    }

    const getSettingsData = () => {
        setIsLoading(true)
        fetchAccountSettingsData({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {
            setIsLoading(false)
        }, (msg: string, resp: any) => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        return () => {
            if ( newWindow.current ) {
                clearInterval(newWindow.current.checkInterval);
                newWindow.current.close();
            }

            if ( newWindow.current && !newWindow.current.closed ) {
                newWindow.current.close();
            }
        }
    }, [])

    useEffect(() => {
        if ( !gustoSession ) {
            navigate(URLS.GUSTO_DASHBOARD)
        }
    }, [gustoSession])

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-12 align-items-center d-flex justify-content-between">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">
                                Create Connection
                            </h1>
                        </div>
                    </div>
                </div>

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                            <div className="loader"></div>
                        </div>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className='d-flex flex-column gap-4'>
                                    <span>Choose Your Preferred Payroll Solution: Gusto</span>
                                    <div className='d-flex gap-4'>
                                        <div className='border' style={{ borderRadius: '5px' }}>
                                            <div className='align-items-center d-flex justify-content-center' style={{ backgroundColor: '#D9D9D9', borderTopRightRadius: '5px', borderTopLeftRadius: '5px'}}>
                                                <img src="gusto.svg" alt="" className='h-70' />
                                            </div>
                                            <div className='align-items-center d-flex gap-1 justify-content-center pb-1 pt-1'>
                                                <input type="radio" id="gusto" name="third-party" value="gusto" checked={selectedItem == 'gusto'} onChange={(e: any) => setSelectedItem(e?.target?.value)} />
                                                <label htmlFor="gusto">Gusto</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-md-5">
                            <div className="col-md-12 d-flex justify-content-end">
                                <Link to={"javascript:void(0)"} className="btn btn-primary" onClick={handleLogin}>
                                    {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : (
                                    <>
                                        <img src="third-party-coonect.svg" alt="" />
                                        <span>Create Connection</span>
                                    </>)}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GustoConnection
